import Logo from "assets/img/brand.png";

import "./style.scss";
import { useForm, SubmitHandler } from "react-hook-form";
import { useCallback, useState } from "react";
import { useAuth } from "context/AuthContext";
import { useNavigate } from "react-router";

type Inputs = {
  email: string;
  pass: string;
};

export function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [invalidUser, setInvalidUser] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();
  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    if (data.email && data.pass) {
      await doLogin(data.email, data.pass);
    }
  };

  const doLogin = useCallback(
    async (username: string, password: string) => {
      try {
        setLoading(true);
        setErrorMessage("");
        await login({ username, password });
        navigate("/");
      } catch (e: any) {
        setLoading(false);
        setInvalidUser(true);

        if (
          typeof e.message === "string" &&
          e.message === "password incorrect for player"
        ) {
          setErrorMessage(
            "O nome de usuário ou senha digitados estão incorretos. Por favor, tente novamente."
          );
        } else {
          setErrorMessage(
            "Ocorreu um erro com sua solicitação. Por favor, tente novamente."
          );
        }
      }
    },
    [login, navigate]
  );

  return (
    <div id="login-wrapper">
      <div className="relative flex items-center w-screen h-screen bg-blue-bg page-login bg-blue-bb">
        <div className="flex flex-col items-center gap-4 px-5 text-center md:items-center md:text-left md:px-0 md:pl-80">
          <img className="block object-cover md:hidden" src={Logo} alt="" />

          <h2 className="font-bold md:text-[45px] text-3xl mb-[18px] font-title text-yellow-bb uppercase">
            Prêmio BB 2024 - Contagem Regressiva <br /> para o Resultado Final!
          </h2>

          <p className="text-white-bb font-medium text-2xl md:text-[28px] md:mb-[30px]">
            Agora é momento de aguardar o resultado final e manter
            <br /> a torcida pela sua iniciativa. Em breve, conheceremos
            <br /> os destaques desta edição, que reconhece, valoriza e celebra
            <br /> as iniciativas que inspiram e promovem transformação.
          </p>

          <>
            <div className="mt-10 w-full rounded-lg sm:max-w-md p-0 border border-white flex flex-col bg-blue-dark ">
              <div className="p-6 space-y-3">
                <h2 className="block text-center text-xl text-yellow-bb font-bold leading-tight tracking-tight md:text-2xl dark:text-white">
                  Entre com seu login e senha
                </h2>
                <form
                  className="space-y-4 md:space-y-6"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div>
                    <label
                      htmlFor="id"
                      className="text-yellow block mb-2 text-sm font-medium dark:text-white"
                    >
                      Matricula
                    </label>
                    <input
                      type="text"
                      id="id"
                      className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 "
                      placeholder="F9999999"
                      {...register("email", { required: true })}
                      disabled={loading}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="password"
                      className="text-yellow block mb-2 text-sm font-medium dark:text-white"
                    >
                      Senha:
                    </label>
                    <input
                      type="password"
                      id="password"
                      placeholder="••••••••"
                      className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 "
                      {...register("pass", { required: true })}
                      disabled={loading}
                    />
                  </div>
                  <div className="flex items-center justify-center">
                    <button
                      className="bg-[#FCF82A] text-[#012D4A] text-base rounded-[4px] px-8 py-4 uppercase font-bold hover:opacity-80 transition-all"
                      type="submit"
                      disabled={loading}
                    >
                      <div className="flex flex-row items-center justify-center space-x-2 p-0 leading-none">
                        {loading ? (
                          <span>Carregando...</span>
                        ) : (
                          <>
                            <span>Clique para entrar</span>
                          </>
                        )}
                      </div>
                    </button>
                  </div>
                  {!!errorMessage && !!errorMessage.length && (
                    <p className="block text-center text-white-bb">
                      {errorMessage}
                    </p>
                  )}
                </form>
              </div>
            </div>
          </>
        </div>
        <div className="relative flex-1 hidden h-screen brand md:block">
          <img
            className="absolute right-0 object-cover"
            src={Logo}
            alt=""
            width={"90%"}
          />
        </div>
      </div>
    </div>
  );
}
